// src/ModalContext.js
import React, { createContext, useContext, useState, useCallback, useRef } from "react";
//import ModalComponent from "../common_components/LookupModal/ModalComponent"; // Import the ModalComponent
import ModalComponent from "../common_components/LookupModal/ModalComponent";

const ModalContext = createContext();

export const ModalProvider = ({ children }) => {
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [screenNumber, setScreenNumber] = useState(null);
  const [modalProps, setModalProps] = useState({});
  const [sourceData, setSourceData] = useState({});
  const [callback, setCallback] = useState(null);
  const [readOnly, setReadOnly] = useState(false);
  const [navigate, setNavigate] = useState(null);
   const [resetLookupMode, setResetLookupMode] = useState(null);
   const lastFocussedElementIdRef = useRef();

  const showModal = useCallback(
    (
      screenNumber,
      props = {},
      onReceiveData,
      formData,
      readOnly = false,
      navigateScreen,
      resetLookupMode,
      lastFocussedElementId = null
    ) => {
      setScreenNumber(screenNumber);
      // setModalComponent(component);
      setModalProps(props);
      setCallback(() => onReceiveData);
      setNavigate(() => navigateScreen);
      setIsModalVisible(true);
      if (formData) {
        setSourceData(formData);
      }
      setReadOnly(readOnly);
      setResetLookupMode(() => resetLookupMode);
      lastFocussedElementIdRef.current ??= lastFocussedElementId;

    },
    []
  );

  const hideModal = useCallback(
    (lookupModeReset = true) => {
      setIsModalVisible(false);
      setScreenNumber(null);
      setModalProps({});
      setCallback(null);
      setReadOnly(false);
      if (lookupModeReset) {
        resetLookupMode && resetLookupMode();
      }
    },
    [resetLookupMode]
  );

  const receiveData = useCallback(
    (data) => {
      if (callback) {
        console.log("tingting");
        callback(data);
      }
      hideModal();
    },
    [callback, hideModal]
  );

  const navigateToScreen = useCallback(
    (data) => {
      if (navigate) {
        navigate(
          data,
          screenNumber,
          modalProps.params,
          sourceData,
          lastFocussedElementIdRef.current
        );
      }
      hideModal();
    },
    [screenNumber, hideModal, modalProps, navigate, sourceData]
  );

  return (
    <ModalContext.Provider
      value={{
        isModalVisible,
        showModal,
        hideModal,
        receiveData,
        screenNumber,
        modalProps,
        sourceData,
        readOnly,
        navigateToScreen,
      }}
    >
      {children}
      <ModalComponent />
    </ModalContext.Provider>
  );
};

export const useModal = () => useContext(ModalContext);
